var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99877 7.64002e-07C6.09509 -0.000155353 6.19009 0.0236166 6.2761 0.0693979C6.36212 0.115179 6.43675 0.181687 6.49396 0.263554L11.9828 8.1364L5.99877 10.2344L0.0147448 8.1364L5.50604 0.263554C5.56301 0.18204 5.63724 0.115748 5.7228 0.0699825C5.80836 0.0242174 5.90287 0.000250766 5.99877 7.64002e-07ZM0.00122866 9.83976L5.50604 17.736C5.56314 17.8178 5.63765 17.8844 5.72356 17.9302C5.80946 17.9761 5.90437 18 6.00061 18C6.09686 18 6.19177 17.9761 6.27767 17.9302C6.36358 17.8844 6.43809 17.8178 6.49519 17.736L12 9.83976L6.24329 11.8599C6.08607 11.9146 5.91639 11.9146 5.75916 11.8599L0.00122866 9.83976Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEth);
export default __webpack_public_path__ + "static/media/icon_eth.091f9f37ccbcd03d9dcec6663a608862.svg";
export { ForwardRef as ReactComponent };